module.exports = __webpack_public_path__ + "img/clothing.b2f34906.png";